import { render, staticRenderFns } from "./FinanicStatics.vue?vue&type=template&id=705df10c&scoped=true&"
import script from "./FinanicStatics.vue?vue&type=script&lang=js&"
export * from "./FinanicStatics.vue?vue&type=script&lang=js&"
import style0 from "./FinanicStatics.vue?vue&type=style&index=0&id=705df10c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705df10c",
  null
  
)

export default component.exports